import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, distinctUntilChanged, map } from 'rxjs';
import { ProductService } from './product.service';

/**
 * Поиск по меню (docs/design/README.md приложения Edim, раздел 14, вариант А):
 * лупа в полосе категорий открывает экран поиска поверх меню
 */
@Injectable({
  providedIn: 'root'
})
export class MenuSearchService {
  /** Лупа — в меню от стольких блюд и напитков вместе (стоп-лист считается) */
  static readonly MIN_ITEMS = 30;

  private openSubject = new BehaviorSubject<boolean>(false);
  public open$: Observable<boolean> = this.openSubject.asObservable();

  /** Меню достаточно большое для поиска */
  public available$: Observable<boolean>;

  constructor(productService: ProductService) {
    this.available$ = combineLatest([productService.foods$, productService.drinks$]).pipe(
      map(([foods, drinks]) => foods.length + drinks.length >= MenuSearchService.MIN_ITEMS),
      distinctUntilChanged(),
    );
  }

  open(): void {
    this.openSubject.next(true);
  }

  close(): void {
    this.openSubject.next(false);
  }
}
